import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./pages/Header";
import Footer from "./pages/Footer";
import MainContent from "./pages/MenuBody";
import AdminPanel from "./pages/AdminPanel";
import Login from "./pages/Login";

function AppWrapper() {
  const [restaurantInfo, setRestaurantInfo] = useState(null);
  const [menuData, setMenuData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Add timestamp to prevent caching
        const timestamp = new Date().getTime();
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/menu.php?t=${timestamp}`);
        const data = await response.json();
        
        console.log("API Response:", data); // Debug: See what's coming from API
        
        if (data.success) {
          console.log("Menu Data:", data.data.menuData); // Debug: Check menu structure
          setRestaurantInfo(data.data.restaurantInfo);
          setMenuData(data.data.menuData);
        } else {
          throw new Error(data.message || 'Failed to fetch data');
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <Box>Loading...</Box>;
  if (error) return <Box>Error: {error}</Box>;
  if (!restaurantInfo) return <Box>No data available</Box>;

  return (
    <Router>
      <Box sx={{ 
        display: "flex", 
        flexDirection: "column", 
        minHeight: "100vh",
        backgroundColor: "#f9f9f9"
      }}>
        <Header restaurantInfo={restaurantInfo} />
        <Routes>
          <Route path="/" element={
            <MainContent 
              menuData={menuData} 
              qrMenuURL={restaurantInfo.qr_menu_url} 
            />
          } />
          <Route path="/admin" element={
            isAuthenticated ? (
              <AdminPanel 
                menuData={menuData}
                restaurantInfo={restaurantInfo}
              />
            ) : (
              <Login setIsAuthenticated={setIsAuthenticated} />
            )
          } />
        </Routes>
        <Footer restaurantInfo={restaurantInfo} />
      </Box>
    </Router>
  );
}

export default AppWrapper;